var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgImportTemplateIconBlack = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 3.33333C18.3332 2.8731 17.9601 2.5 17.4998 2.5H2.49984C2.0396 2.5 1.6665 2.8731 1.6665 3.33333V16.6667C1.6665 17.1269 2.0396 17.5 2.49984 17.5H17.4998C17.9601 17.5 18.3332 17.1269 18.3332 16.6667V3.33333ZM3.33317 12.5H6.17987C6.82284 13.9716 8.29124 15 9.99984 15C11.7084 15 13.1768 13.9716 13.8198 12.5H16.6665V15.8333H3.33317V12.5ZM3.33317 4.16667H16.6665V10.8333H12.4998C12.4998 12.2141 11.3806 13.3333 9.99984 13.3333C8.61909 13.3333 7.49984 12.2141 7.49984 10.8333H3.33317V4.16667ZM13.3332 7.5H10.8332V5H9.1665V7.5H6.6665L9.99984 11.25L13.3332 7.5Z",
    fill: "#1B1F1E"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgImportTemplateIconBlack, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ImportTemplateIconBlack.71ca633e.svg";
export { ForwardRef as ReactComponent };